import { render, staticRenderFns } from "./CardDentistaSelecionadoOrcamento.vue?vue&type=template&id=19bfcbe0&scoped=true"
import script from "./CardDentistaSelecionadoOrcamento.vue?vue&type=script&lang=js"
export * from "./CardDentistaSelecionadoOrcamento.vue?vue&type=script&lang=js"
import style0 from "./CardDentistaSelecionadoOrcamento.vue?vue&type=style&index=0&id=19bfcbe0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bfcbe0",
  null
  
)

export default component.exports